import { BillingCategoryCode } from './Receipt'
import Tenant, { TenantData } from './Tenant'

///////////////////////////////////
// Type
///////////////////////////////////

export const EmailType = {
  PC: 0,
  Mobile: 1,
}
export type EmailType = (typeof EmailType)[keyof typeof EmailType]

export const MeterType = {
  SmartMeter: 0,
  Analog: 1,
} as const
export type MeterType = (typeof MeterType)[keyof typeof MeterType]

///////////////////////////////////
// User
///////////////////////////////////

export type UserData = {
  id: number
  code: string
  firstName: string | null
  lastName: string
  firstNameKana: string | null
  lastNameKana: string
  phoneNumber1: string | null
  email: string
  emailType: EmailType
  roomTypeName: string | null
  hasGasMeter: boolean
  hasEVCharger: boolean
  meterType: MeterType

  tenant: TenantData
}

export default class User {
  declare id: number
  declare code: string
  declare firstName: string | null
  declare lastName: string
  declare firstNameKana: string | null
  declare lastNameKana: string
  declare phoneNumber1: string | null
  declare email: string
  declare emailType: EmailType
  declare roomTypeName: string | null
  declare hasGasMeter: boolean
  declare hasEVCharger: boolean
  declare meterType: MeterType

  declare tenant: Tenant

  // Computed properties ------------------------------------------------------

  get codeForDisplay() {
    return this.code.slice(0, 8)
  }

  get name() {
    if (!this.firstName) return this.lastName
    return `${this.lastName} ${this.firstName}`
  }

  get displayName() {
    if (this.tenant.billingCategory.code !== BillingCategoryCode.AccountTransfer) return this.name
    return this.tenant.payerName || this.name
  }

  get kana() {
    if (!this.firstNameKana) return this.lastNameKana
    return `${this.lastNameKana} ${this.firstNameKana}`
  }

  get building() {
    return this.tenant.room.building
  }

  get buildingName() {
    return this.building.name
  }

  get roomName() {
    return this.tenant.room.name
  }

  get isSmartMeter() {
    return this.meterType === MeterType.SmartMeter
  }

  // Constructor --------------------------------------------------------------

  constructor(params: UserData) {
    Object.assign(this, params)
    this.tenant = new Tenant(params.tenant)
  }
}
